import { useMutation, useQueryClient } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { API_URL, IFieldStateType, IOrganizationPropertiesStateConfigRequestDto } from '@/dtos';

import { useFieldLevelAccessSetupStore } from '../FieldLevelAccessSetup/stores';
import { QUERY_KEY } from '../queries/useGetLevelAccessById.query.ts';
import { IFieldLevelAccessSetup } from '../role.types';
import { useHighlightNewFieldLevelAccessStore } from '../stores';

interface Params {
  onClose?: () => void;
  onError?: () => void;
  isEditMode?: boolean;
}
const OCCUPIED_NAME_TEXT = 'Details: FieldLevel Access with name ';
const useCreateFieldLevelAccessQuery = (params?: Params) => {
  const queryClient = useQueryClient();
  const setErrorFields = useFieldLevelAccessSetupStore((state) => state.setErrorFields);
  const setHighlightedId = useHighlightNewFieldLevelAccessStore((state) => state.setHighlightId);
  const { isLoading, isSuccess, mutateAsync } = useMutation(
    (payload: IFieldLevelAccessSetup) => {
      const currentBody: Partial<IOrganizationPropertiesStateConfigRequestDto> = {
        name: payload.name,
        description: payload.description,
        properties: payload.properties as unknown as Record<string, IFieldStateType>,
        overridable_properties: payload.overridableProperties as unknown as Record<string, IFieldStateType>,
      };
      return params?.isEditMode
        ? api.put<unknown, IOrganizationPropertiesStateConfigRequestDto>(
            API_URL.ORGANIZATION_PROPERTIES_STATE_CONFIGS_BY_ID(payload.id),
            currentBody
          )
        : api.post<unknown, IOrganizationPropertiesStateConfigRequestDto>(
            API_URL.ORGANIZATION_PROPERTIES_STATE_CONFIGS,
            currentBody
          );
    },
    {
      onSuccess: async (response) => {
        const id = _.get(response, 'data.id');
        setHighlightedId(`${id || ''}`);

        await queryClient.invalidateQueries({
          queryKey: [QUERY_KEY],
        });
      },
      onError: (response, variables) => {
        const message = _.get(response, 'response.data.elevate_error_message', '');
        if (message.includes(OCCUPIED_NAME_TEXT)) {
          if (params?.onClose) {
            params?.onClose();
          }
          setErrorFields({
            name: {
              value: variables.name,
              message: 'FieldLevel Access with this name already exists',
            },
          });
        } else {
          if (params?.onError) {
            params?.onError();
          }
        }
      },
    }
  );
  return {
    isLoading,
    isSuccess,
    handleSave: mutateAsync,
  };
};
export default useCreateFieldLevelAccessQuery;
